<template>
  <header
    :class="[
      'js-header fixed top-0 left-0 w-full z-max transform translate-y-0 transition-transform duration-200 ease-in-out',
      {
        '-translate-y-header-top-mobile lg:-translate-y-header-top-desktop': isShrinked,
        'shadow-header': isScrolling,
      },
      { 'translate-y-0': !isShrinked },
      {
        'z-chatbot-back': !isMobileOpen,
        'z-chatbot-front': isMobileOpen,
      },
    ]"
  >
    <ShortcutNav
      v-if="!slim"
      :navItems="shortcutsNav"
      :savedUrl="savedUrl"
      :searchUrl="searchUrl"
    />

    <div
      :class="[
        'relative z-50 transition-colors duration-200 ease-in-out',
        { 'bg-transparent': isMobileOpen },
        { 'bg-white': !isMobileOpen },
      ]"
    >
      <div class="o-wrapper">
        <div
          :class="[
            'h-header-main-mobile lg:h-header-main-desktop flex flex-nowrap items-center',
          ]"
        >
          <Logo />

          <!-- DESKTOP NAV -->
          <nav class="flex mobile+tablet:hidden items-center mx-auto">
            <ul
              class="flex flex-grow-0 items-start justify-evenly list-none lg:flex-nowrap xl:items-center"
            >
              <li
                v-for="(navItem, index) in computedNav"
                :key="navItem.id"
                :class="['group-megamenu py-6.5', index === 0 ? '' : 'ml-5']"
              >
                <a
                  :href="navItem.url"
                  :target="navItem.newWindow ? '_blank' : '_self'"
                  :class="[
                    'u-body-sm text-center xl:text-left xl:u-body-md group relative inline-block text-primary-navy font-bold focus:outline-none before:hidden hover:before:block before:w-full before:h-6.5 before:absolute before:top-full before:left-0 before:cursor-default',
                    navItem.classes,
                    {
                      'cursor-default': !navItem.url,
                    },
                  ]"
                  @focus="openDesktopMegamenu(navItem.id)"
                  @blur="closeDesktopMegamenu(false)"
                  @mouseover="openDesktopMegamenu(navItem.id)"
                  @mouseleave="closeDesktopMegamenu(false)"
                >
                  <span
                    :class="[
                      'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                    ]"
                  ></span>
                  <span
                    :class="[
                      'hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                    ]"
                  >
                    {{ navItem.title }}
                  </span>
                </a>
                <transition
                  v-if="
                    navItem.children && activeDesktopMegamenu === navItem.id
                  "
                  appear
                  :key="`megamenu-${navItem.id}`"
                  enter-class="menu-enter"
                  enter-active-class="menu-enter-active"
                  enter-to-class="menu-enter-to"
                  leave-class="menu-leave"
                  leave-active-class="menu-leave-active"
                  leave-to-class="menu-leave-to"
                >
                  <!-- COMMUNITY MEGAMENU -->
                  <MegamenuAlternative
                    v-if="
                      navItem.attributes !== null &&
                        navItem.attributes.megamenuType === 'communities'
                    "
                    type="communities"
                    :navItem="navItem"
                    :communities="communities"
                    :closeDesktopMegamenu="closeDesktopMegamenu"
                    :openDesktopMegamenu="openDesktopMegamenu"
                    :nearbyRedirectUrl="findCommunitiesUrl"
                    :enquireUrl="enquireUrl"
                  />

                  <!-- HOMES FOR SALE MEGAMENU -->
                  <MegamenuAlternative
                    v-else-if="
                      navItem.attributes !== null &&
                        navItem.attributes.megamenuType === 'homesForSale'
                    "
                    type="homesForSale"
                    :navItem="navItem"
                    :communities="communities"
                    :closeDesktopMegamenu="closeDesktopMegamenu"
                    :openDesktopMegamenu="openDesktopMegamenu"
                    :nearbyRedirectUrl="findHomesUrl"
                    :enquireUrl="enquireUrl"
                  />

                  <!-- DEFAULT ORIGINAL MEGAMENU -->
                  <MegamenuDefault
                    v-else
                    :navItem="navItem"
                    :closeDesktopMegamenu="closeDesktopMegamenu"
                    :openDesktopMegamenu="openDesktopMegamenu"
                  />
                </transition>
              </li>
            </ul>
          </nav>
          <!--  -->

          <!-- DESKTOP RIGHT CTAS -->
          <div class="mr-3 mobile+tablet:ml-auto">
            <CtaButton
              buttonType="secondary"
              label="1300&nbsp;50&nbsp;55&nbsp;60"
              url="tel:1300358210"
              :clickFunction="callClickHandle"
              labelClassList="hidden xs:inline"
              iconId="icon-phone"
              iconClassList="w-4 h-4 md:w-6 md:h-6 lg:w-4 lg:h-4 xl:w-6 xl:h-6 xs:mr-2"
            />
          </div>
          <div class="mobile+tablet:hidden">
            <CtaButton
              buttonType="primary"
              :label="enquireBookCtaLabel"
              :url="enquireBookCtaUrl"
            />
          </div>
          <!--  -->

          <!-- MOBILE HAMBURGER ICON -->
          <button
            type="button"
            :class="[
              'hamburger hamburger--elastic border border-solid rounded-lg transition-colors duration-200 ease-in-out lg:hidden',
              { 'is-active border-primary-navy': isMobileOpen },
              { 'border-primary': !isMobileOpen },
            ]"
            aria-label="!isMobileOpen ? 'Open menu' : 'Close menu'"
            :aria-expanded="isMobileOpen ? true : false"
            @click="!isMobileOpen ? openMobileMenu() : closeMobileMenu()"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
          <!--  -->
        </div>
      </div>
    </div>

    <MobileNavMenu
      ref="mobileNavMenu"
      :isMobileOpen="isMobileOpen"
      :nav="mobileNav"
      :communities="communities"
      :enquireCtaLabel="enquireBookCtaLabel"
      :enquireCtaUrl="enquireBookCtaUrl"
      :savedUrl="savedUrl"
      :searchUrl="searchUrl"
      :findCommunitiesUrl="findCommunitiesUrl"
      :findHomesUrl="findHomesUrl"
    />
  </header>
</template>

<script>
import {
  BODY,
  WINDOW,
  lockScrolling,
  unlockScrolling,
} from '../../helpers/browser';
import VueLazyDirective from '../../directives/v-lazy';
import ShortcutNav from './components/ShortcutNav.vue';
import Logo from './components/Logo.vue';
import MegamenuDefault from './components/MegamenuDefault.vue';
import MegamenuAlternative from './components/MegamenuAlternative.vue';
import MobileNavMenu from './components/MobileNavMenu/index.vue';
import CtaButton from '../CtaButton.vue';
import dataLayerPush from '../../helpers/dataLayerPush';

export default {
  directives: {
    lazy: VueLazyDirective,
  },
  components: {
    ShortcutNav,
    Logo,
    MegamenuDefault,
    MegamenuAlternative,
    MobileNavMenu,
    CtaButton,
  },
  props: {
    mainNav: {
      type: Array,
      required: true,
    },
    mobileNav: {
      type: Array,
      required: true,
    },
    shortcutsNav: {
      type: Array,
      required: true,
    },
    communities: {
      type: Array,
      required: true,
    },
    enquireUrl: {
      type: String,
      required: true,
    },
    savedUrl: {
      type: String,
      required: true,
    },
    searchUrl: {
      type: String,
      required: true,
    },
    findCommunitiesUrl: {
      type: String,
      required: true,
    },
    findHomesUrl: {
      type: String,
      required: true,
    },
    communitySlug: {
      type: String,
      default: null,
    },
    communityAppointmentEndpoint: {
      type: String,
      default: null,
    },
    slim: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobileOpen: false,
      isShrinked: false,
      isScrolling: false,
      timeoutMegamenu: false,
      activeDesktopMegamenu: '',
      // activeDesktopMegamenu: '837f9d57-ba77-4f07-b4f3-dcd9812c23a7', // COMMUNTIIES
      // activeDesktopMegamenu: 'afa4ba96-7a2f-43bb-9519-9cdac6841e4c', // HOMES
      previousScrollPosition: null,
    };
  },
  computed: {
    computedNav() {
      const mainNav = [];
      this.mainNav.forEach(item => {
        if (item.children) {
          const currentItem = Object.assign({}, item);

          if (
            item.attributes !== null &&
            !Object.keys(item.attributes).includes('megamenuType') &&
            item.children.length > 5
          ) {
            // filter out 6th item onwards
            const removed = item.children.slice(5);
            currentItem.children = currentItem.children.slice(0, 5);

            // add 6th item onwards into 5th item's children
            currentItem.children[4] = {
              ...currentItem.children[4],
              children: currentItem.children[4].children
                ? [...currentItem.children[4].children, ...removed]
                : [...removed],
            };
          }

          // if sub-subheading type is CTA, propagate to child nodes
          currentItem.children.forEach(child => {
            if (child.headerNavType) {
              child.children.forEach(
                grandchild => (grandchild.headerNavType = true)
              );
            }
          });

          mainNav.push(currentItem);
          return;
        }
        mainNav.push(item);
      });
      return mainNav;
    },
    enquireBookCtaLabel() {
      return this.communityAppointmentEndpoint !== null
        ? 'Book&nbsp;a&nbsp;tour'
        : 'Enquire&nbsp;now';
    },
    enquireBookCtaUrl() {
      return this.communityAppointmentEndpoint !== null
        ? `/book-a-tour?communityName=${encodeURIComponent(
            this.communityAppointmentEndpoint
          )}`
        : this.enquireUrl;
    },
  },
  mounted() {
    // add classes to <body> to accommodate header's existence
    // BODY.classList.add('pt-header-mobile');
    // BODY.classList.add('lg:pt-header-desktop');

    this.previousScrollPosition = WINDOW.pageYOffset;
    WINDOW.addEventListener('scroll', this.onScrollHandler);
  },
  methods: {
    openDesktopMegamenu(megamenuId) {
      this.activeDesktopMegamenu = megamenuId;
      if (this.timeoutMegamenu) {
        clearTimeout(this.timeoutMegamenu);
        this.timeoutMegamenu = null;
      }
      lockScrolling();
    },
    closeDesktopMegamenu(instant = false) {
      if (this.timeoutMegamenu) {
        clearTimeout(this.timeoutMegamenu);
        this.timeoutMegamenu = null;
      }
      if (instant) {
        this.activeDesktopMegamenu = '';
        unlockScrolling();
      } else {
        this.timeoutMegamenu = setTimeout(() => {
          this.activeDesktopMegamenu = '';
          unlockScrolling();
        }, 400);
      }
    },
    openMobileMenu() {
      this.isMobileOpen = true;
      lockScrolling();
    },
    closeMobileMenu() {
      this.isMobileOpen = false;
      if (this.$refs.mobileNavMenu)
        this.$refs.mobileNavMenu.resetAllActiveSubMenus();
      unlockScrolling();
    },
    onScrollHandler(e) {
      const currentScrollPosition = WINDOW.pageYOffset;
      const scrollingDown = currentScrollPosition > this.previousScrollPosition;

      if (currentScrollPosition > 40) {
        this.isScrolling = true;
      } else {
        this.isScrolling = false;
      }

      if (scrollingDown) {
        if (BODY.classList.contains('scroll-disabled')) return;
        if (!this.isMobile) {
          if (WINDOW.pageYOffset > 40) {
            this.isShrinked = true;
            BODY.classList.add('header-is-shrinked');
            this.offsetTop = 0;
          } else {
            this.isShrinked = false;
            BODY.classList.remove('header-is-shrinked');
            this.offsetTop = -Math.abs(Math.max(WINDOW.pageYOffset, 0));
          }
        } else {
          this.isShrinked = false;
          BODY.classList.remove('header-is-shrinked');
          this.offsetTop = 0;
        }
      } else {
        if (BODY.classList.contains('scroll-disabled')) return;
        if (!this.isMobile) {
          this.isShrinked = false;
          BODY.classList.remove('header-is-shrinked');
          this.offsetTop = -Math.abs(Math.max(WINDOW.pageYOffset, 0));
        }
      }

      this.previousScrollPosition = currentScrollPosition;
    },
    callClickHandle() {
      dataLayerPush({
        event: 'call',
        ...(this.communitySlug !== null && {
          community: this.communitySlug,
        }),
        currency: 'AUD',
        value: 30,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-enter-active {
  @apply transition-all duration-200 ease-in-out;
}
.menu-leave-active {
  @apply transition-all duration-200 ease-in-out;
}
.menu-enter,
.menu-leave-to {
  @apply -translate-y-8 opacity-0;
}
.menu-enter-to,
.menu-leave {
  @apply translate-y-0 opacity-100;
}
</style>
